import type {
  Notification,
  NotificationGroupedByDate,
} from '../../interface/Notification';
import { useSession } from 'next-auth/react';
import { useQuery } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

export const useGetNotifications = () => {
  const { data: session } = useSession();
  return useQuery({
    queryKey: ['notifications'],
    queryFn: getNotifications,
    enabled: !!session && !!session.access_token,
  });
};

const getNotifications = async () => {
  const { data } = await api.get<{ data: NotificationGroupedByDate }>(
    apiConfig.routes.notifications
  );

  const grouped = Object.values(data.data).flat();

  const notificationsData: NotificationsDataGrouoped = {
    notifications: grouped,
    today_new_quantity: data?.data?.HOJE?.length,
  };

  return notificationsData;
};

type NotificationsDataGrouoped = {
  notifications: Notification[];
  today_new_quantity: number;
};
